// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pagination styles */
.styled-pagination .MuiPagination-ul {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .styled-pagination .MuiPaginationItem-root {
    border-radius: 10px;
  }
  
  .styled-pagination .MuiPaginationItem-root.Mui-selected {
    background-color: white;
    border: 2px solid #ff7f1e;
  }
  
  .styled-pagination .MuiPaginationItem-previous,
  .styled-pagination .MuiPaginationItem-next {
    border-radius: 24px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .styled-pagination .MuiPaginationItem-previous {
    background-color: #d3d3d3;
  }
  
  .styled-pagination .MuiPaginationItem-next {
    background-color: #ff7f1e;
  }
  
  /* Select styles */
  .styled-select {
    min-width: 80px;
    height: 30px;
    border-radius: 100px;
    margin-left: 8px;
  }
  
  /* TextField styles */
  .styled-textfield {
    width: 60px;
    margin-left: 8px;
  }
  
  .styled-textfield .MuiOutlinedInput-root {
    border-radius: 100px;
    height: 30px;
    padding: 0 8px;
  }
  
  .styled-textfield .MuiOutlinedInput-input {
    text-align: center;
    padding: 5px 0;
    appearance: none;
    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Chrome, Safari, Edge */
  }
  
  .styled-textfield input[type="number"]::-webkit-outer-spin-button,
  .styled-textfield input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  .styled-textfield input[type="number"] {
    -moz-appearance: textfield; /* For Firefox */
  }
  
  /* Button styles */
  #styled-button {
    background-color: #f15e22;
    color: white;
    min-width: 37px;
    height: 30px;
    border-radius: 24px;
  }
  
  /* Text styles */
  .styled-text {
    color: #404042cc;
    font-size: 12px;
    font-weight: 400;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pagination/pagination.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;;IAEE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,yBAAyB;EACrD;;EAEA;;IAEE,wBAAwB;IACxB,SAAS;EACX;;EAEA;IACE,0BAA0B,EAAE,gBAAgB;EAC9C;;EAEA,kBAAkB;EAClB;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB","sourcesContent":["/* Pagination styles */\n.styled-pagination .MuiPagination-ul {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .styled-pagination .MuiPaginationItem-root {\n    border-radius: 10px;\n  }\n  \n  .styled-pagination .MuiPaginationItem-root.Mui-selected {\n    background-color: white;\n    border: 2px solid #ff7f1e;\n  }\n  \n  .styled-pagination .MuiPaginationItem-previous,\n  .styled-pagination .MuiPaginationItem-next {\n    border-radius: 24px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .styled-pagination .MuiPaginationItem-previous {\n    background-color: #d3d3d3;\n  }\n  \n  .styled-pagination .MuiPaginationItem-next {\n    background-color: #ff7f1e;\n  }\n  \n  /* Select styles */\n  .styled-select {\n    min-width: 80px;\n    height: 30px;\n    border-radius: 100px;\n    margin-left: 8px;\n  }\n  \n  /* TextField styles */\n  .styled-textfield {\n    width: 60px;\n    margin-left: 8px;\n  }\n  \n  .styled-textfield .MuiOutlinedInput-root {\n    border-radius: 100px;\n    height: 30px;\n    padding: 0 8px;\n  }\n  \n  .styled-textfield .MuiOutlinedInput-input {\n    text-align: center;\n    padding: 5px 0;\n    appearance: none;\n    -moz-appearance: none; /* Firefox */\n    -webkit-appearance: none; /* Chrome, Safari, Edge */\n  }\n  \n  .styled-textfield input[type=\"number\"]::-webkit-outer-spin-button,\n  .styled-textfield input[type=\"number\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  \n  .styled-textfield input[type=\"number\"] {\n    -moz-appearance: textfield; /* For Firefox */\n  }\n  \n  /* Button styles */\n  #styled-button {\n    background-color: #f15e22;\n    color: white;\n    min-width: 37px;\n    height: 30px;\n    border-radius: 24px;\n  }\n  \n  /* Text styles */\n  .styled-text {\n    color: #404042cc;\n    font-size: 12px;\n    font-weight: 400;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
